// Tradução dos erros de conta (sem depender do Better Auth, para não o puxar para o pacote principal).

/** Códigos de erro do Better Auth que os formulários traduzem (o resto cai em "erro genérico"). */
export const AUTH_ERRORS = [
  "INVALID_EMAIL_OR_PASSWORD",
  "EMAIL_NOT_VERIFIED",
  "USER_ALREADY_EXISTS",
  "USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL",
  "PASSWORD_TOO_SHORT",
  "PASSWORD_TOO_LONG",
  "INVALID_PASSWORD",
  "INVALID_TOKEN",
  "INVALID_CODE",
  "INVALID_TWO_FACTOR_CODE",
  "TOO_MANY_ATTEMPTS",
  "BANNED_USER",
] as const;

/** Converte um erro do cliente (ou do backend) numa chave de tradução "auth.errors.<código>". */
export function authErrorKey(err: { status?: number; code?: string; message?: string } | null | undefined): string {
  if (!err) return "auth.errors.generic";
  if (err.status === 429) return "auth.errors.TOO_MANY_REQUESTS";
  if (err.message === "registrations_closed" || err.code === "registrations_closed") return "auth.errors.registrations_closed";
  // O último admin não pode apagar a conta (backend: deleteUser.beforeDelete).
  if (err.message === "last_admin" || err.code === "last_admin") return "auth.errors.last_admin";
  const code = (err.code ?? "").toUpperCase();
  if (code === "USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL") return "auth.errors.USER_ALREADY_EXISTS";
  if (code === "INVALID_TWO_FACTOR_CODE") return "auth.errors.INVALID_CODE";
  if ((AUTH_ERRORS as readonly string[]).includes(code)) return `auth.errors.${code}`;
  if (/banned/i.test(err.message ?? "")) return "auth.errors.BANNED_USER";
  return "auth.errors.generic";
}
